export default __webpack_public_path__ + "static/O0185-9ab5a14da9228d562b46ded91ee921b1.png";